import { render, staticRenderFns } from "./MyNavbar.vue?vue&type=template&id=2e1c3924&scoped=true"
import script from "./MyNavbar.vue?vue&type=script&lang=js"
export * from "./MyNavbar.vue?vue&type=script&lang=js"
import style0 from "./MyNavbar.vue?vue&type=style&index=0&id=2e1c3924&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1c3924",
  null
  
)

export default component.exports